<template>
	<div class="dankal-image-upload">
		<p v-for="(item,index) in list" :key="index">
			<video :id="'myVideo'+currentIndex" :src="getVideoSrc(item)" controls="controls"
				ref="videoPlayer" width="800" height="300">
				您的浏览器不支持 video 标签。
			</video>
			<img class="close" src="@/assets/images/ic_delete.png" @click="onDeleted(index)" v-if="!disabled">
		</p>
		<div class="add-box flex flex-c" @click="onSelected" v-if="list.length < limit && !disabled">
			<i class="el-icon-video-camera" style="font-size: 52px;color: #999;"></i>
			<div class="cla">点击上传视频文件</div>
			<div class="cla">请上传横屏视频</div>
			<el-button type="primary" style="width: 150px;margin-top: 10px;height: 35px;"
				class="flex flex-c">上传视频</el-button>
		</div>
		<input ref="input" type="file" id="file" accept="video/*" style="display:none;" @change="onFileChanged">
	</div>
</template>

<script>
	import ImageCompressor from "image-compressor.js";
	import {
		uploadImgFile,
		qiniuInfo
	} from "@/api/common";
	import {
		imgDomain
	} from '@/configs/env';
	import {
		mapState,
		mapActions
	} from "vuex";

	export default {
		name: "DankalImageUpload",
		data() {
			return {
				imgDomain,
				list: [],
				toast: "",
				file_type: this.type, //图片还是视频
				skipValueSync: false, // 上传后用签名 url 预览，避免被 result 覆盖
			};
		},
		created() {},
		props: {
			value: {
				type: [Array, String],
				required: true
			},
			currentIndex: {
				type: Number,
				default: 0
			},
			limit: {
				type: Number,
				default: 3
			},
			quatity: {
				type: Number,
				default: 0.6
			},
			type: {
				type: String,
				default: "image"
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			...mapState(["bucket_domain_token"])
		},
		mounted() {},
		watch: {
			value: {
				immediate: true,
				handler(newVal) {
					if (this.skipValueSync) {
						this.skipValueSync = false;
						return;
					}
					if (newVal) {
						const src = this.getVideoSrc(newVal);
						this.list = src ? [src] : [];
					} else {
						this.list = [];
					}
				}
			}
		},
		methods: {
			...mapActions(["getUrlAndTokenOfImageUpload"]),
			// 解析上传返回：预览用 url，保存用 result
			parseUploadData(data) {
				const payload = data || {};
				const nested = payload.result && typeof payload.result === 'object' ? payload.result : null;
				const savePath = nested
					? (nested.result || nested.file_path || '')
					: (typeof payload.result === 'string' ? payload.result : '');
				const previewPath = nested
					? (nested.url || nested.result || '')
					: (payload.url || savePath);
				return {
					savePath,
					previewPath
				};
			},
			getVideoSrc(item) {
				let src = item;
				if (item && typeof item === 'object') {
					src = item.url || item.result || item.file_path || '';
				}
				if (!src) return '';
				return src.indexOf('http') !== -1 ? src : imgDomain + src;
			},
			onSelected() {
				const {
					limit,
					list
				} = this;

				if (limit && list.length >= limit) {
					this.$message(`只能上传${limit}张图片`);
					return;
				}
				this.$refs.input.click();
			},

			onDeleted(index) {
				// Array.prototype.splice(this.list, index, 1);
				this.list.splice(index, 1);
				//不置空 删除之后上传同张图片无法出发change事件
				this.$refs.input.value = "";
				this.skipValueSync = false;
				this.$emit("input", this.list, this.currentIndex, 0);
			},

			onFileChanged(event) {
				const file = event.target.files[0];
				const {
					type
				} = file;
				this.getUrlAndTokenOfImageUpload();
				if (!file) return;
				if (type.indexOf("image") !== -1) {
					this.file_type = "image";
				}
				if (type.indexOf("video") !== -1) {
					this.file_type = "video";
				}
				this.upload(file);
			},
			async upload(file) {
				let that = this
				const formData = new FormData();
				formData.append('file', file);
				var url = "/common/Upload";
				const res = await uploadImgFile(url, formData).catch(() => {});
				if (res.status === 200) {
					const {
						savePath,
						previewPath
					} = that.parseUploadData(res.data);
					// 预览用签名 url，保存只回传 result
					that.skipValueSync = true;
					that.list = [that.getVideoSrc(previewPath)];
					that.$emit('input', [savePath], that.currentIndex, 0);
					that.$nextTick(() => {
						var video = document.getElementById('myVideo' + that.currentIndex);
						if (!video) return;
						video.addEventListener('canplaythrough', function onReady() {
							video.removeEventListener('canplaythrough', onReady);
							that.skipValueSync = true;
							that.$emit('input', [savePath], that.currentIndex, video.duration);
						}, false);
					})
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		display: flex;
		flex-wrap: wrap;

		p {
			position: relative;
			min-width: 800px;
			min-height: 150px;
			float: left;

			.upload_img {
				width: 150px;
				height: 150px;
				object-fit: cover;
			}

			.close {
				width: 20px;
				height: 20px;
				position: absolute;
				right: 0;
				cursor: pointer;
			}
		}

		.add-box {
			display: flex;
			flex-direction: column;
			margin-top: 20px;
			border-width: 0px;
			width: 650px;
			height: 268px;
			background: inherit;
			background-color: rgba(242, 242, 242, 1);
			border-radius: 12px;

			.cla {
				font-size: 16px;
				color: #000;
				line-height: 30px;
			}
		}
	}
</style>